import { AxiosInstance } from 'axios';

import { achievementsEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { AchievementsResponse } from './AchievementsApi.schema';

class AchievementsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getAchievements = async (): Promise<AchievementsResponse> => {
    return this.#requestInstance.get(achievementsEndpoints.achievementsAvailable);
  };
}

export const achievementsApi = new AchievementsApi(axios);
